<p-splitButton
  #splitButton
  [label]="label"
  [disabled]="disabled"
  (onClick)="onClick.emit()"
  [style]="styles"
  class="u-split-button"
></p-splitButton>
